const url = '/generalAccounts';
const Provider = 'GeneralAccounts';
const dbModel = 'GeneralAccounts';

export { url, Provider, dbModel };
